import { render, staticRenderFns } from "./EvolveTask.vue?vue&type=template&id=664cc6a6"
import script from "./EvolveTask.vue?vue&type=script&lang=js"
export * from "./EvolveTask.vue?vue&type=script&lang=js"
import style0 from "./EvolveTask.vue?vue&type=style&index=0&id=664cc6a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports